import { cn } from "@/lib/formatters";

type State = "ok" | "warn" | "danger" | "info" | "off";

const colorMap: Record<State, string> = {
  ok:     "text-success",
  warn:   "text-warn",
  danger: "text-danger",
  info:   "text-primary",
  off:    "text-muted",
};

interface LEDDotProps {
  state: State;
  size?: number;
  pulse?: boolean;
  className?: string;
  label?: string;
}

export function LEDDot({ state, size = 8, pulse = true, className, label }: LEDDotProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-2", colorMap[state], className)}
      role="status"
      aria-label={label ?? `status: ${state}`}
    >
      <span
        style={{ width: size, height: size }}
        className={cn(
          "inline-block rounded-full bg-current",
          pulse && state !== "off" && "animate-pulse-led",
        )}
      />
      {label && <span className="text-xs font-mono uppercase tracking-wider">{label}</span>}
    </span>
  );
}
